var map = {
	"./Blue_Arrow_L.svg": 43456,
	"./Blue_Arrow_R.svg": 84566,
	"./Comment.svg": 31738,
	"./Down.svg": 11663,
	"./Error-Page.svg": 32861,
	"./Help_dc.svg": 46306,
	"./Left.svg": 23152,
	"./Read.svg": 57375,
	"./Reply-blue-ltr.svg": 74651,
	"./Reply-blue-rtl.svg": 10779,
	"./Resize_BLUE.svg": 86678,
	"./Right.svg": 75359,
	"./RtR_New_Logo.svg": 54360,
	"./Share.svg": 96952,
	"./X.svg": 82261,
	"./arrow-down.svg": 96187,
	"./arrow-right.svg": 38851,
	"./arrow-up.svg": 21876,
	"./arrow_down_blue.svg": 14756,
	"./arrow_down_yellow.svg": 65328,
	"./arrow_up_yellow.svg": 23333,
	"./bin.svg": 30714,
	"./book.svg": 91096,
	"./border-image.svg": 929,
	"./calendar.svg": 69421,
	"./cart-white.svg": 44001,
	"./chain.svg": 69042,
	"./checkbox-selected.svg": 13466,
	"./checkbox-unselected.svg": 80003,
	"./checkbox_Checked.svg": 22594,
	"./checkbox_idle.svg": 92209,
	"./chevron-left.svg": 62746,
	"./chevron-right.svg": 24913,
	"./circle.svg": 25731,
	"./close-circle.svg": 31486,
	"./close-mw.svg": 24466,
	"./close.svg": 64321,
	"./download.svg": 60051,
	"./eye.svg": 96822,
	"./facebook.svg": 98635,
	"./filter-option.svg": 6321,
	"./filter.svg": 28453,
	"./flag-filled.svg": 99070,
	"./flag.svg": 12933,
	"./info-grey.svg": 90609,
	"./instagram.svg": 84409,
	"./label-text.svg": 92085,
	"./language_24dp.svg": 92266,
	"./linkedin.svg": 60781,
	"./loader.svg": 87742,
	"./mail.svg": 87018,
	"./mail_24dp.svg": 32451,
	"./menu_dc.svg": 18786,
	"./onMicIcon.svg": 7670,
	"./pen.svg": 60304,
	"./placeholder.svg": 6486,
	"./play.svg": 10113,
	"./playIcon.svg": 50878,
	"./plus-circle.svg": 29964,
	"./plus.svg": 10511,
	"./read_white.svg": 15385,
	"./reader-view-back-button.svg": 57337,
	"./reader-view-fullscreen-exit.svg": 3703,
	"./reader-view-fullscreen.svg": 69406,
	"./reader-view-next-page.svg": 71298,
	"./reader-view-previous-page.svg": 31854,
	"./reader-view-read-to-me.svg": 96880,
	"./reader-view-read2me-fs.svg": 63077,
	"./reader-view-zoom-in-fs.svg": 82160,
	"./reader-view-zoom-in.svg": 35168,
	"./reader-view-zoom-out-fs.svg": 66377,
	"./reader-view-zoom-out.svg": 93055,
	"./refresh.svg": 73332,
	"./rtr-logo.svg": 46407,
	"./sort.svg": 63755,
	"./success.svg": 58704,
	"./translate.svg": 24911,
	"./up.svg": 1760,
	"./user-image.svg": 83886,
	"./user.svg": 99566,
	"./video.svg": 61228,
	"./website.svg": 92678,
	"./whatsapp.svg": 99061,
	"./youtube.svg": 27706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42744;